import { Component, Input, OnChanges, output, SimpleChanges } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-list',
    imports: [FontAwesomeModule],
    templateUrl: './list.component.html'
})
export class ListComponent implements OnChanges {
  @Input() loading = false;
  @Input() items: any[] = [];
  @Input() columns: string[] = [];

  rowClick = output<any>();

  deleteRow = output<any>();

  faTrash = faTrash;
  deletingItemIndex: number | null = null;

  // This method will be called whenever any @Input property changes
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.deletingItemIndex = null;
    }
  }

  deleteItem(item: any, index: number) {
    this.deletingItemIndex = index; // Track the index of the deleting item
    this.deleteRow.emit(item);
  }
}
